import { render, staticRenderFns } from "./AIInsightsModal.vue?vue&type=template&id=24d2796a&scoped=true"
import script from "./AIInsightsModal.vue?vue&type=script&lang=js"
export * from "./AIInsightsModal.vue?vue&type=script&lang=js"
import style0 from "./AIInsightsModal.vue?vue&type=style&index=0&id=24d2796a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2796a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1820143640/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d2796a')) {
      api.createRecord('24d2796a', component.options)
    } else {
      api.reload('24d2796a', component.options)
    }
    module.hot.accept("./AIInsightsModal.vue?vue&type=template&id=24d2796a&scoped=true", function () {
      api.rerender('24d2796a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIInsightsModal.vue"
export default component.exports